@if (control) {
  <mat-slide-toggle
    appearance="outline"
    [formControl]="control"
    [required]="required"
    [ngClass]="{ disabled: control.disabled }"
    [matTooltip]="tooltip ? (tooltip | translate) : ''"
    [matTooltipClass]="tooltipClass"
    (change)="onChange($event)"
  >
    {{ label }}
  </mat-slide-toggle>
}
